export const typeOfAlertCreateSuccessDialog = 'typeOfAlertCreateSuccessDialog';
